import * as angular from 'angular';

(function () {
    'use strict';
    angular.module('app').service('countryService', countryService);

    function countryService($log, COUNTRIES) {
        return {
            getCountryByCode: function (countries, countryCode) {
                for (var countryIndex in countries) {
                    if (countryCode == countries[countryIndex].code) {
                        return countries[countryIndex];
                    }
                }
                $log.error('Country code "' + countryCode + '" is unknown');
                return false;
            },
            getCountryByName: function (countries, countryName) {
                for (var countryIndex in countries) {
                    if (countryName == countries[countryIndex].name) {
                        return countries[countryIndex];
                    }
                }
                $log.error('Country name "' + countryName + '" is unknown');
                return false;
            },
            getByCode: function (countryCode) {
                return this.getCountryByCode(COUNTRIES, countryCode);
            },
            getByName: function (countryName) {
                return this.getCountryByName(COUNTRIES, countryName);
            }
        };
    }
})();
